import '../style/input-q81DbuHZ.css'
import { defineComponent as K, useCssVars as Q, unref as o, useModel as W, useSlots as X, toRef as C, ref as y, watch as Y, nextTick as B, useAttrs as Z, computed as d, openBlock as t, createElementBlock as r, normalizeClass as x, renderSlot as i, createCommentVNode as l, createElementVNode as M, withDirectives as ee, mergeProps as se, isRef as oe, toHandlers as te, vModelText as ne, createBlock as f, withModifiers as re, Fragment as ie, withCtx as m, toDisplayString as z, createVNode as F } from "vue";
import { useFocus as le } from "@vueuse/core";
import ae from "./spinner.js";
import I from "./tooltip.js";
import { useInputSize as ue } from "./hooks/useInputSize.js";
import pe from "./internalComponents/CrossIcon.js";
import { FOCUS_EVENT as de, BLUR_EVENT as fe, CHANGE_EVENT as ce, UPDATE_MODEL_VALUE as me, INPUT_EVENT as _e, CLEAR_EVENT as ve } from "./constant/events.js";
import { useInputEvent as ge } from "./hooks/useInputEvent.js";
import { useInputClass as ye } from "./hooks/useInputClass.js";
import { useFormItem as Ee } from "./hooks/useFormItem.js";
import E from "./internalComponents/InputInfoIcon.js";
const he = {
  key: 0,
  class: "e-input__prepend"
}, ke = {
  key: 0,
  class: "e-input__prefix"
}, $e = ["id", "aria-label", "placeholder", "disabled"], Ve = {
  key: 3,
  class: "e-input__suffix"
}, be = {
  key: 1,
  class: "e-input__error-msg"
}, Ce = {
  key: 1,
  class: "e-input__info-msg"
}, Be = {
  key: 1,
  class: "e-input__append"
}, He = /* @__PURE__ */ K({
  name: "e-input",
  __name: "input",
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    placeholder: {},
    size: {},
    loading: { type: Boolean },
    isError: { type: Boolean, default: void 0 },
    clearable: { type: Boolean },
    focused: { type: Boolean, default: !1 },
    height: {},
    alignRight: { type: Boolean },
    errorMessage: {},
    infoMessage: {}
  },
  emits: [de, fe, ce, me, _e, ve],
  setup(N, { expose: R, emit: S }) {
    Q((e) => ({
      "291434b5": o(A)
    }));
    const n = N, p = W(n, "modelValue", { local: !0 }), a = X(), { formItem: h, formSize: T } = Ee(), { height: A, actualSize: k } = ue({ formSize: T, propSize: C(n, "size"), propHeight: C(n, "height") }), $ = S, _ = y(!1), v = y(!1), c = y(), { focused: g } = le(c);
    Y(() => n.focused, (e) => {
      B(() => {
        g.value = e;
      });
    }, { immediate: !0 });
    const V = Z(), w = ["class", "style", "value", "placeholder", "disabled"], U = d(() => {
      const e = {};
      for (const s in V)
        w.includes(s) || (e[s] = V[s]);
      return e;
    }), D = d(() => n.modelValue ?? p.value), b = d(() => n.isError ?? j.value), H = d(() => ({
      size: k.value,
      disabled: n.disabled,
      error: b.value,
      prepend: !!a.prepend,
      append: !!a.append,
      focus: g.value,
      alignRight: n.alignRight
    })), { inputClass: L } = ye("input", H), {
      handleInput: O,
      handleBlur: P,
      handleFocus: G,
      isFormItemError: j
    } = ge($), q = d(() => ({
      input: O,
      focus: G,
      blur: P
    }));
    function J() {
      p.value = "", $("clear");
    }
    return R({
      inputRef: c,
      triggerFocus: async () => {
        await B(), g.value = !0;
      }
    }), (e, s) => (t(), r("div", {
      class: x(o(L))
    }, [
      o(a).prepend ? (t(), r("div", he, [
        i(e.$slots, "prepend")
      ])) : l("", !0),
      M("div", {
        class: "e-input__wrapper",
        onMouseenter: s[3] || (s[3] = (u) => v.value = !0),
        onMouseleave: s[4] || (s[4] = (u) => v.value = !1),
        onClick: s[5] || (s[5] = (u) => c.value?.focus())
      }, [
        o(a).prefix ? (t(), r("div", ke, [
          i(e.$slots, "prefix")
        ])) : l("", !0),
        ee(M("input", se({
          id: o(h).formItemId,
          ref_key: "inputRef",
          ref: c,
          "onUpdate:modelValue": s[0] || (s[0] = (u) => oe(p) ? p.value = u : null),
          "aria-label": o(h).label,
          class: "e-input__inner",
          type: "text",
          placeholder: e.placeholder,
          disabled: e.disabled
        }, U.value, te(q.value, !0), {
          onFocus: s[1] || (s[1] = (u) => _.value = !0),
          onBlur: s[2] || (s[2] = (u) => _.value = !1)
        }), null, 16, $e), [
          [ne, o(p)]
        ]),
        i(e.$slots, "default"),
        (v.value || _.value) && e.clearable && !e.disabled && D.value !== "" ? (t(), f(pe, {
          key: 1,
          size: o(k),
          class: "e-input__icon",
          onClick: re(J, ["stop"])
        }, null, 8, ["size"])) : l("", !0),
        e.loading ? (t(), f(o(ae), {
          key: 2,
          color: "--text-primary",
          size: "24",
          class: "e-input__icon"
        })) : l("", !0),
        o(a).suffix ? (t(), r("div", Ve, [
          i(e.$slots, "suffix")
        ])) : l("", !0),
        b.value ? (t(), r(ie, { key: 4 }, [
          e.errorMessage ? (t(), f(o(I), { key: 0 }, {
            content: m(() => [
              e.$slots["error-message"] ? i(e.$slots, "error-message", { key: 0 }) : (t(), r("span", be, z(e.errorMessage), 1))
            ]),
            default: m(() => [
              F(E, {
                "is-error": "",
                class: "e-input__icon e-input__error-icon"
              })
            ]),
            _: 3
          })) : (t(), f(E, {
            key: 1,
            "is-error": "",
            class: "e-input__icon e-input__error-icon"
          }))
        ], 64)) : e.infoMessage ? (t(), f(o(I), { key: 5 }, {
          content: m(() => [
            e.$slots["info-message"] ? i(e.$slots, "info-message", { key: 0 }) : (t(), r("span", Ce, z(e.infoMessage), 1))
          ]),
          default: m(() => [
            F(E, { class: "e-input__icon e-input__info-icon" })
          ]),
          _: 3
        })) : l("", !0)
      ], 32),
      o(a).append ? (t(), r("div", Be, [
        i(e.$slots, "append")
      ])) : l("", !0)
    ], 2));
  }
});
export {
  He as default
};
//# sourceMappingURL=input.js.map
